module.exports = __webpack_public_path__ + "img/svg-pin.95039511.svg";